import { Flex, Icon, Text } from '@cad-arc';
import { EntityTypes, MergedEntityTypes, Vehicle } from '../../../../../fr-entity-panels/types';
import { getVehicleTitle, getEntityDescription } from '../helpers';
import { CommonSize } from '../../../../../common/helpers/utils';
import { MasterVehicleLinkButton } from '../../../../../panels/entity-panels/forms/vehicles/entity-panel-form-vehicle-card-controls';

export function VehicleCardTileFields({
    vehicle,
    index,
    entityType,
    size = 'sm',
}: {
    vehicle: Vehicle;
    index: number;
    entityType: EntityTypes | MergedEntityTypes;
    size?: CommonSize;
}) {
    const {
        plateNumber,
        stateOption,
        colorOption,
        vehicleMakeOption,
        vehicleModelOption,
        involvementTypeOption,
        involvementTypeOther,
    } = vehicle;

    return (
        <>
            <Flex margin={0} padding={0} alignItems="center" gap="5px">
                <Text
                    fontWeight="bold"
                    fontSize={size == 'sm' ? 'md' : size}
                    style={{ wordBreak: 'break-word' }}
                >
                    {getVehicleTitle({ plateNumber, state: stateOption?.label, index, entityType })}
                </Text>
                {Object.values(MergedEntityTypes).includes(entityType as MergedEntityTypes) && (
                    <Icon icon="Merge" />
                )}
                <MasterVehicleLinkButton
                    isPersisted={vehicle.isPersisted}
                    masterVehicleId={vehicle.eventMasterVehicleData?.id}
                />
            </Flex>
            {involvementTypeOption?.label && (
                <Text fontSize={size} color="tertiary" style={{ marginTop: 0 }}>
                    {`${involvementTypeOption.label}${
                        involvementTypeOther ? ` (${involvementTypeOther})` : ''
                    }`}
                </Text>
            )}
            <Text fontSize={size} color="tertiary" style={{ marginTop: 0 }}>
                {getEntityDescription([
                    colorOption?.label,
                    vehicleMakeOption?.label,
                    vehicleModelOption?.label,
                ])}
            </Text>
        </>
    );
}
